import React, {
	useEffect, useMemo, useRef, useState,
} from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import useShots from '../../hooks/use-shots';

interface SpotlightProps {
    spotlightId: string;
    elementToPortal: string;
	mediaId: number;
}

const Spotlight: React.FC<SpotlightProps> = ({ spotlightId, elementToPortal, mediaId }) => {
	const myRef = useRef<HTMLDivElement | null>(null);
	const [unmanagedDiv, setUnmanagedDiv] = useState<HTMLDivElement | null>(null);

	const {
		currentShot,
	} = useShots();

	const {
		shot_data: {
			shotFeeds,
		},
	} = currentShot;
	const isOnCurrentShot = useMemo(() => shotFeeds?.some((feed:any) => feed.media === mediaId), [shotFeeds, mediaId]);
	const shotData = useMemo(() => shotFeeds?.find((feed:any) => feed.media === mediaId), [shotFeeds, mediaId]);
	const feedPosition = shotData?.position;
	const hiddenContainer = document.getElementById('hidden-spotlight');
	const container = document.getElementById(`feed-${feedPosition}`);

	useEffect(() => {
		const divExists = document.getElementById(spotlightId);
		let createdDiv: HTMLDivElement;
		if (divExists) {
			createdDiv = divExists as HTMLDivElement;
		} else {
			createdDiv = document.createElement('div');
			createdDiv.id = spotlightId;
		}

		setUnmanagedDiv(createdDiv);
		return () => {
			// Clean up the DOM element
			createdDiv.remove();
		};
	}, []);

	useEffect(() => {
		if (myRef.current && unmanagedDiv) {
			myRef.current.appendChild(unmanagedDiv);
		}
	}, [myRef.current, unmanagedDiv, container]);

	const actualContainer = useMemo(() => {
		console.log('Changing container', isOnCurrentShot, container, hiddenContainer);
		return isOnCurrentShot ? container : hiddenContainer;
	}, [isOnCurrentShot, container, hiddenContainer]);
	return (
        <>
            { actualContainer
                && ReactDOM.createPortal(<div id={`spotlight-holder-${spotlightId}`} className='spotlight' ref={myRef}></div>, actualContainer)
            }
        </>
	);
};

export default Spotlight;
